/* PEN'UP 3D Éducation — Theme JS — Lightweight, zero-dependency */
(function () {
  'use strict';

  /* ==================================================================
     1. MOBILE MENU + SEARCH DRAWER (nouveau header)
     ==================================================================
     Sélecteurs : data-open-menu / data-close-menu / data-open-search / data-close-search
     Bascule aria-expanded sur le burger et aria-hidden sur les drawers. */

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(drawer, trigger) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function getMobileNav()  { return document.getElementById('mobile-nav'); }
  function getSearchDrawer(){ return document.getElementById('search-drawer'); }
  function getBurger()     { return document.querySelector('[data-open-menu]'); }

  document.addEventListener('click', function (e) {
    // Open menu
    if (e.target.closest('[data-open-menu]')) {
      openDrawer(getMobileNav(), getBurger());
      return;
    }
    // Close menu
    if (e.target.closest('[data-close-menu]') || e.target.closest('.mobile-nav__overlay')) {
      closeDrawer(getMobileNav(), getBurger());
      return;
    }
    // Open search
    if (e.target.closest('[data-open-search]')) {
      openDrawer(getSearchDrawer(), null);
      // focus input for instant typing
      var input = document.querySelector('.search-drawer__input');
      if (input) setTimeout(function(){ input.focus(); }, 100);
      return;
    }
    // Close search
    if (e.target.closest('[data-close-search]') || e.target.closest('.search-drawer__overlay')) {
      closeDrawer(getSearchDrawer(), null);
      return;
    }
  });

  // ESC ferme tout drawer ouvert
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var nav = getMobileNav();
    var srch = getSearchDrawer();
    if (nav && nav.classList.contains('is-open'))   closeDrawer(nav, getBurger());
    if (srch && srch.classList.contains('is-open')) closeDrawer(srch, null);
  });

  /* ==================================================================
     2. HEADER — état "is-scrolled" pour ombre subtile
     ================================================================== */
  var hdr = document.getElementById('site-header');
  if (hdr) {
    var lastScroll = -1;
    var onScroll = function () {
      var y = window.scrollY;
      if (lastScroll === -1 || (y > 6) !== (lastScroll > 6)) {
        hdr.classList.toggle('is-scrolled', y > 6);
      }
      lastScroll = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ==================================================================
     3. CART DRAWER — logique préservée à 100%
     ================================================================== */
  function openCart() {
    var d = document.querySelector('.cart-drawer');
    if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  }
  function closeCart() {
    var d = document.querySelector('.cart-drawer');
    if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__cart-btn') || e.target.closest('[data-open-cart]')) {
      e.preventDefault();
      openCart();
      refreshCart();
    }
    if (e.target.closest('.cart-drawer__close') || e.target.closest('.cart-drawer__overlay')) {
      closeCart();
    }
  });

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(console.error);
  }

  function renderCart(cart) {
    var body = document.querySelector('.cart-drawer__body');
    var footer = document.querySelector('.cart-drawer__footer');
    var countEls = document.querySelectorAll('.cart-count-bubble');

    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><div class="cart-drawer__empty-icon">🛒</div><p>Votre panier est vide</p></div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = 'block';

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[^.]+)$/, '_small$1') + '" alt="' + item.title + '" loading="lazy">' : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      html += '<div class="line-item">' +
        '<div class="line-item__image">' + img + '</div>' +
        '<div class="line-item__info">' +
          '<div class="line-item__title">' + item.product_title + '</div>' +
          (variantTitle ? '<div class="line-item__variant">' + variantTitle + '</div>' : '') +
          '<div class="line-item__bottom">' +
            '<span class="line-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '<span style="font-size:13px;color:var(--c-text-muted)">×' + item.quantity + '</span>' +
          '</div>' +
          '<button class="line-item__remove" data-remove-key="' + item.key + '">Retirer</button>' +
        '</div>' +
      '</div>';
    });
    body.innerHTML = html;

    var totalEl = document.querySelector('.cart-drawer__total-price');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  // Remove item
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-remove-key]');
    if (!removeBtn) return;
    var key = removeBtn.dataset.removeKey;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); })
      .then(refreshCart)
      .catch(console.error);
  });

  /* ==================================================================
     4. AJAX ADD TO CART — préservé à 100%
     ================================================================== */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Ajout en cours…'; }

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Erreur');
      return r.json();
    })
    .then(function () {
      openCart();
      refreshCart();
      if (btn) { btn.textContent = '✓ Ajouté !'; setTimeout(function () { btn.disabled = false; btn.textContent = origText; }, 1500); }
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = origText; }
      alert('Impossible d\'ajouter au panier. Veuillez réessayer.');
    });
  });

  /* ==================================================================
     5. QUANTITY SELECTOR — préservé
     ================================================================== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-selector__btn');
    if (!btn) return;
    var input = btn.parentElement.querySelector('.qty-selector__input');
    if (!input) return;
    var val = parseInt(input.value) || 1;
    if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
    else val++;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ==================================================================
     6. VARIANT PICKER — préservé
     ================================================================== */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.variant-picker__opt');
    if (!opt || opt.classList.contains('is-unavailable')) return;

    var picker = opt.closest('.variant-picker');
    picker.querySelectorAll('.variant-picker__opt').forEach(function (o) { o.classList.remove('is-active'); });
    opt.classList.add('is-active');

    var variantId = opt.dataset.variantId;
    if (!variantId) return;

    var form = opt.closest('form') || document.querySelector('form[action="/cart/add"]');
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variantId;
    }

    var price = opt.dataset.price;
    var compare = opt.dataset.compare;
    var priceEl = document.querySelector('.product-info__price');
    var compareEl = document.querySelector('.product-info__compare');
    if (priceEl && price) priceEl.textContent = formatMoney(parseInt(price));
    if (compareEl) {
      if (compare && parseInt(compare) > parseInt(price)) {
        compareEl.textContent = formatMoney(parseInt(compare));
        compareEl.style.display = 'inline';
      } else {
        compareEl.style.display = 'none';
      }
    }

    var available = opt.dataset.available !== 'false';
    var addBtn = document.querySelector('.product-add-btn');
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Ajouter au panier' : 'Épuisé';
    }

    var img = opt.dataset.image;
    if (img) {
      var mainImg = document.querySelector('.product-gallery__main img');
      if (mainImg) mainImg.src = img;
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }
  });

  /* ==================================================================
     7. PRODUCT GALLERY THUMBNAILS — préservé
     ================================================================== */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;
    var img = thumb.querySelector('img');
    if (!img) return;
    var mainImg = document.querySelector('.product-gallery__main img');
    if (mainImg) {
      mainImg.src = img.src.replace('_small', '').replace('_compact', '').replace('_medium', '_large');
    }
    thumb.parentElement.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ==================================================================
     8. INIT : Refresh cart count + counter animation au scroll
     ================================================================== */
  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  });

  /* ==================================================================
     9. STAT COUNTER ANIMATION — IntersectionObserver
        (déplacé depuis theme.liquid pour éviter le JS inline blocking)
     ================================================================== */
  function animateCounter(el, target, suffix, duration) {
    var start = 0;
    var isDecimal = target % 1 !== 0;
    var step = target / (duration / 16);
    var timer = setInterval(function () {
      start += step;
      if (start >= target) {
        start = target;
        clearInterval(timer);
      }
      el.textContent = (isDecimal ? start.toFixed(1) : Math.floor(start).toLocaleString('fr-FR')) + suffix;
    }, 16);
  }

  function initStatCounters() {
    var stats = document.querySelectorAll('.hero__stat-num');
    if (!stats.length) return;

    if (!('IntersectionObserver' in window)) {
      // fallback : montre directement
      stats.forEach(function (el) { el.classList.add('visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stats.forEach(function (el) {
            el.classList.add('visible');
            var target = parseFloat(el.dataset.count);
            var suffix = el.dataset.suffix || '';
            if (!isNaN(target)) animateCounter(el, target, suffix, 1500);
          });
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(stats[0]);
  }

  /* ==================================================================
     10. BACK-TO-TOP + PROGRESS BAR — déplacés ici (defer)
     ================================================================== */
  function initBackToTop() {
    var btn = document.getElementById('backToTop');
    if (!btn) return;
    var onScroll = function () { btn.classList.toggle('visible', window.scrollY > 300); };
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  function initProgressBar() {
    var bar = document.getElementById('progressBar');
    if (!bar) return;
    var onScroll = function () {
      var scrollTop = window.scrollY;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var progress = (scrollTop / docHeight) * 100;
      bar.style.width = progress + '%';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // init après DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStatCounters();
      initBackToTop();
      initProgressBar();
    });
  } else {
    initStatCounters();
    initBackToTop();
    initProgressBar();
  }

})();
